/** Lee app_settings; null si no existe o SQLite no disponible (ram-only: stub retorna null). */
export async function getAppSettingSafe(key: string): Promise<string | null> {
  return null;
}

/** Guarda app_settings (ram-only: stub no-op, no persiste). */
export async function persistAppSettingSafe(key: string, value: string): Promise<void> {
  return;
}
